// extracted by mini-css-extract-plugin
export default {"productCarousel":"T4-z"};